export const WEB_VERSION = '1.0.24';
